<div class="not-found-container">
  <div class="not-found text-center">
    <img src="./assets/img/project/icons/404-error.webp" alt="404">
    <h1 class="mb-3 error-heading">ERROR</h1>
    <h2 class="mb-3">{{ 'PAGE_NOT_FOUND' | translate }}</h2>
    <h4 class="mb-3">{{ 'PAGE_NOT_EXIST' | translate }}</h4>
    <a class="btn btn-lg btn-primary" routerLink="/home">
      {{ 'GO_TO_HOMEPAGE' | translate }}
    </a>
  </div>
</div>
